import React, { useMemo, useState } from 'react';
import { useData } from '../context/DataContext';
import { useAuth, isTecnico } from '../context/AuthContext';
import { useToast } from '../components/Toast';
import Modal from '../components/Modal';
import ServiceTag, { SERVICIOS } from '../components/ServiceTag';

const URGENCIA_COLORS = {
  'alta':  { background: '#fee2e2', color: '#dc2626' },
  'media': { background: '#fef9c3', color: '#854d0e' },
  'baja':  { background: '#dcfce7', color: '#16a34a' }
};

export default function Clientes() {
  const { clientes, loading, importLeads, toggleAgendado, updateCliente, notas } = useData();
  const { users } = useAuth();
  const toast = useToast();

  const [q, setQ] = useState('');
  const [filtroServicio, setFiltroServicio] = useState('');
  const [verCliente, setVerCliente] = useState(null);
  const [editCliente, setEditCliente] = useState(null);

  const tecnicos = users.filter(u => isTecnico(u.rol));
  const mostradores = users.filter(u => u.rol === 'Mostrador' || u.rol === 'Administrador');

  const lista = useMemo(() => {
    let l = [...clientes].reverse(); // más nuevos primero
    if (filtroServicio) l = l.filter(c => c.servicio === filtroServicio);
    if (q.trim()) {
      const s = q.toLowerCase();
      l = l.filter(c =>
        (c.nombre || '').toLowerCase().includes(s) ||
        (c.whatsapp || '').toLowerCase().includes(s) ||
        (c.descripcion || '').toLowerCase().includes(s) ||
        (c.equipo || '').toLowerCase().includes(s) ||
        (c.ciudad || '').toLowerCase().includes(s) ||
        (c.atiende || '').toLowerCase().includes(s) ||
        (c.tecnico || '').toLowerCase().includes(s)
      );
    }
    return l;
  }, [clientes, q, filtroServicio]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <h1 style={{ fontSize: 20, fontWeight: 800, marginRight: 'auto' }}>Clientes</h1>
        <button className="btn-secondary" onClick={() => { importLeads(); toast.show('Sincronizando con Google Sheets…'); }}>
          {loading ? '⏳ Sincronizando…' : '🔄 Sincronizar'}
        </button>
      </div>

      <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
        <input
          type="text" placeholder="Buscar por nombre, teléfono, motivo, mostrador o técnico…"
          value={q} onChange={e => setQ(e.target.value)} style={{ maxWidth: 380 }}
        />
        <select value={filtroServicio} onChange={e => setFiltroServicio(e.target.value)} style={{ maxWidth: 280 }}>
          <option value="">Todos los servicios</option>
          {SERVICIOS.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <div style={{ alignSelf: 'center', fontSize: 13, color: '#94a3b8', fontWeight: 600 }}>
          {lista.length} cliente{lista.length === 1 ? '' : 's'}
        </div>
      </div>

      <div className="card table-wrap" style={{ overflow: 'auto' }}>
        <table>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Nombre</th>
              <th>WhatsApp</th>
              <th>Servicio</th>
              <th>Urgencia</th>
              <th>Ciudad</th>
              <th>Técnico</th>
              <th>Agendado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.map(c => (
              <tr key={c.id}>
                <td style={{ whiteSpace: 'nowrap' }}>{c.fecha || '—'}</td>
                <td style={{ fontWeight: 600 }}>{c.nombre}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {c.whatsapp ? (
                    <a href={`https://wa.me/${c.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer">
                      {c.whatsapp}
                    </a>
                  ) : '—'}
                </td>
                <td><ServiceTag servicio={c.servicio} /></td>
                <td><Urgencia val={c.urgencia} /></td>
                <td>{c.ciudad || '—'}</td>
                <td>{c.tecnico || <span style={{ color: '#94a3b8' }}>Sin asignar</span>}</td>
                <td>
                  <button
                    onClick={() => { toggleAgendado(c); toast.show(c.estatus === 'Agregado' ? 'Marcado como pendiente' : 'Marcado como agendado'); }}
                    style={{
                      border: 'none', borderRadius: 999, padding: '4px 12px', fontSize: 12, fontWeight: 700,
                      background: c.estatus === 'Agregado' ? '#dcfce7' : '#f1f5f9',
                      color: c.estatus === 'Agregado' ? '#16a34a' : '#94a3b8'
                    }}>
                    {c.estatus === 'Agregado' ? '✓ Agendado' : 'Pendiente'}
                  </button>
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <button className="btn-secondary" style={{ padding: '5px 10px', fontSize: 13, marginRight: 6 }} onClick={() => setVerCliente(c)}>Ver</button>
                  <button className="btn-primary" style={{ padding: '5px 10px', fontSize: 13 }} onClick={() => setEditCliente(c)}>Editar</button>
                </td>
              </tr>
            ))}
            {!lista.length && (
              <tr><td colSpan={9} style={{ textAlign: 'center', color: '#94a3b8', padding: 30 }}>
                {loading ? 'Cargando clientes…' : 'No hay clientes que coincidan con la búsqueda.'}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL VER */}
      {verCliente && (
        <Modal title="Detalle del cliente" onClose={() => setVerCliente(null)} width={620}>
          <Detalle cliente={verCliente} notas={notas.filter(n => n.clienteId === verCliente.id)} />
        </Modal>
      )}

      {/* MODAL EDITAR */}
      {editCliente && (
        <Modal title={'Editar — ' + editCliente.nombre} onClose={() => setEditCliente(null)}>
          <EditForm
            cliente={editCliente}
            tecnicos={tecnicos}
            mostradores={mostradores}
            onSave={async (fields) => {
              await updateCliente(editCliente, fields);
              setEditCliente(null);
              toast.show('Cliente actualizado y enviado al Sheet');
            }}
          />
        </Modal>
      )}
    </div>
  );
}

function Urgencia({ val }) {
  if (!val) return <span style={{ color: '#94a3b8' }}>—</span>;
  const key = String(val).toLowerCase();
  const style = URGENCIA_COLORS[key] || { background: '#f1f5f9', color: '#475569' };
  return <span style={{ ...style, padding: '3px 10px', borderRadius: 999, fontSize: 12, fontWeight: 700, textTransform: 'capitalize' }}>{val}</span>;
}

function Detalle({ cliente, notas }) {
  const Row = ({ label, value }) => (
    <div style={{ display: 'grid', gridTemplateColumns: '170px 1fr', gap: 10, padding: '7px 0', borderBottom: '1px solid #f1f5f9', fontSize: 14 }}>
      <div style={{ color: '#475569', fontWeight: 600 }}>{label}</div>
      <div style={{ whiteSpace: 'pre-wrap' }}>{value || <span style={{ color: '#94a3b8' }}>—</span>}</div>
    </div>
  );
  return (
    <div>
      <Row label="Fecha de solicitud" value={cliente.fecha} />
      <Row label="Nombre completo" value={cliente.nombre} />
      <Row label="WhatsApp" value={cliente.whatsapp} />
      <Row label="Tipo de servicio" value={cliente.servicio} />
      <Row label="Equipo relacionado" value={cliente.equipo} />
      <Row label="Descripción" value={cliente.descripcion} />
      <Row label="Urgencia" value={cliente.urgencia} />
      <Row label="Ciudad" value={cliente.ciudad} />
      <Row label="Atendió en Mostrador" value={cliente.atiende} />
      <Row label="Técnico que atendió" value={cliente.tecnico} />
      <Row label="Estatus" value={cliente.estatus} />
      <Row label="Notas (Sheet)" value={cliente.notaSheet} />
      <div style={{ marginTop: 14 }}>
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6 }}>Notas del sistema</div>
        {!notas.length && <div style={{ fontSize: 13, color: '#94a3b8' }}>Sin notas registradas en el sistema.</div>}
        {notas.map(n => (
          <div key={n.id} style={{ background: '#f8fafc', borderRadius: 8, padding: '8px 12px', marginBottom: 6, fontSize: 13 }}>
            <div style={{ whiteSpace: 'pre-wrap' }}>{n.texto}</div>
            <div style={{ color: '#94a3b8', fontSize: 12, marginTop: 4 }}>
              {n.autor} · {new Date(n.fecha).toLocaleString('es-MX')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function EditForm({ cliente, tecnicos, mostradores, onSave }) {
  const [atiende, setAtiende] = useState(cliente.atiende || '');
  const [tecnico, setTecnico] = useState(cliente.tecnico || '');
  const [nuevaNota, setNuevaNota] = useState('');
  const L = ({ children }) => <label style={{ fontSize: 13, fontWeight: 600, color: '#475569', display: 'block', margin: '10px 0 5px' }}>{children}</label>;

  return (
    <div>
      <L>Atendió en Mostrador</L>
      <select value={atiende} onChange={e => setAtiende(e.target.value)}>
        <option value="">— Seleccionar —</option>
        {mostradores.map(u => <option key={u.id} value={u.nombre}>{u.nombre}</option>)}
        {atiende && !mostradores.some(u => u.nombre === atiende) && <option value={atiende}>{atiende}</option>}
      </select>

      <L>Técnico que atendió</L>
      <select value={tecnico} onChange={e => setTecnico(e.target.value)}>
        <option value="">— Sin asignar —</option>
        {tecnicos.map(u => <option key={u.id} value={u.nombre}>{u.nombre} ({u.rol})</option>)}
        {tecnico && !tecnicos.some(u => u.nombre === tecnico) && <option value={tecnico}>{tecnico}</option>}
      </select>

      <L>Agregar nota (se acumula en el Sheet)</L>
      <textarea rows={3} value={nuevaNota} onChange={e => setNuevaNota(e.target.value)} placeholder="Escribe una nota…" />

      <button
        className="btn-primary" style={{ width: '100%', marginTop: 16 }}
        onClick={() => onSave({ atiende, tecnico, ...(nuevaNota.trim() ? { nuevaNota: nuevaNota.trim() } : {}) })}>
        Guardar cambios
      </button>
    </div>
  );
}
